import { useState } from 'react'

export interface ToastProps {
    id: string
    type: 'success' | 'error' | 'warning' | 'info'
    title: string
    message?: string
    duration?: number
    onClose: (id: string) => void
}

// Hook para gerenciar toasts
export const useToast = () => {
    const [toasts, setToasts] = useState<ToastProps[]>([])

    const addToast = (toast: Omit<ToastProps, 'id' | 'onClose'>) => {
        const id = Math.random().toString(36).substr(2, 9)
        const newToast: ToastProps = {
            ...toast,
            id,
            onClose: (toastId: string) => {
                setToasts(prev => prev.filter(t => t.id !== toastId))
            }
        }
        setToasts(prev => [...prev, newToast])

        // Auto remove after duration or 5 seconds
        setTimeout(() => {
            removeToast(id)
        }, toast.duration || 5000)
    }

    const removeToast = (id: string) => {
        setToasts(prev => prev.filter(toast => toast.id !== id))
    }

    const clearAll = () => {
        setToasts([])
    }

    const showSuccess = (title: string, message?: string) => {
        addToast({ type: 'success', title, message })
    }

    const showError = (title: string, message?: string) => {
        addToast({ type: 'error', title, message })
    }

    const showWarning = (title: string, message?: string) => {
        addToast({ type: 'warning', title, message })
    }

    const showInfo = (title: string, message?: string) => {
        addToast({ type: 'info', title, message })
    }

    return {
        toasts,
        addToast,
        removeToast,
        clearAll,
        showSuccess,
        showError,
        showWarning,
        showInfo
    }
}
